/**
 * Created by DynamicDog on 2017-02-20.
 */
import {Injectable} from '@angular/core';

@Injectable()
export class NetworkService {
    public imagePath='images';
    private entries:Array<any> = [
        {
            contestant:'Anja Pettersson',
            title: 'Aprikos päron ingefära',
            uuid: 'anja'
        },
        {
            contestant: 'Lena Lund',
            title: 'Rabarber jordgubb vanilj',
            uuid:'kalle'
        },
        {
            contestant: 'Lotta lundgren',
            title: 'Tomat morot chili',
            uuid: 'torkel'
        }
    ];

    // Get a list of entries in the competition.
    public getEntries() : Array<any> {
        return this.entries;
    }

    // Upload an entry to server.
    public upload(entry:Object):void {
    }

    public likeEntry(uuid:string):void {

    }


}


// WEBPACK FOOTER //
// ./app/services/network.service.ts